import React from "react";
import PropTypes from "prop-types";
import SwipeableCarousel from "./swipeable-carousel";
import ProductInterface from "../interfaces/product-interface";
import { analytics } from "rtr-constants";
import { userDataPropType } from "components/propTypes";

const ProductCarousel = ({
  closeModal,
  customHeartLoggingOptions,
  dispatch,
  extraPixelData,
  isRentable,
  isFullBleedCarousel,
  isPeekCarousel,
  logStylesInView,
  products,
  shortlists,
  type,
  userData,
  noModelImageFirst,
  isClearance,
  title,
}) => {
  return (
    <ProductInterface
      closeModal={closeModal}
      customHeartLoggingOptions={customHeartLoggingOptions}
      dispatch={dispatch}
      extraPixelData={extraPixelData}
      isRentable={isRentable}
      logStylesInView={logStylesInView}
      products={products}
      shortlists={shortlists}
      userData={userData}
      isFullBleedCarousel={isFullBleedCarousel}
      isPeekCarousel={isPeekCarousel}
      useSmoothScroll={isFullBleedCarousel}
      component={SwipeableCarousel}
      location={analytics.ACTION_LOCATIONS.CAROUSEL}
      locationType={type}
      noModelImageFirst={noModelImageFirst}
      isClearanceProduct={isClearance || false}
      title={title}
    />
  );
};

ProductCarousel.propTypes = {
  closeModal: PropTypes.func.isRequired,
  customHeartLoggingOptions: PropTypes.object,
  dispatch: PropTypes.func.isRequired,
  extraPixelData: PropTypes.object,
  isRentable: PropTypes.bool,
  isFullBleedCarousel: PropTypes.bool,
  isPeekCarousel: PropTypes.bool,
  logStylesInView: PropTypes.func,
  products: PropTypes.arrayOf(PropTypes.object).isRequired,
  shortlists: PropTypes.arrayOf(PropTypes.object),
  type: PropTypes.string,
  userData: userDataPropType,
  noModelImageFirst: PropTypes.bool,
  isClearance: PropTypes.bool,
  title: PropTypes.string,
};

export default ProductCarousel;
